import { render, staticRenderFns } from "./ContainerItems.vue?vue&type=template&id=108165b0&lang=pug&"
import script from "./ContainerItems.vue?vue&type=script&lang=js&"
export * from "./ContainerItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports